/**
 * This converts the given rate to its decimal equivalent
 * For Example if you provide the rate of 13 it will return 0.13
 * @param rate The rate
 * @returns {number}
 */
export const rateToDecimal = (rate: number): number => Number(rate / 100);
